import { Expose } from 'class-transformer';
import * as L from 'leaflet';
import { LatLng } from 'leaflet';
import { Nameable } from 'src/app/common/model/nameable';
import { Positionable } from 'src/app/map/model/positionable';

export const GPS_FRAME_PHANTOM_SOURCE = 'GPS_FRAME_PHANTOM_SOURCE';

export class GPSPhantomFrame implements Positionable, Nameable {

  @Expose({ name: 'courseName' })
  courseName: string;
  @Expose({ name: 'vehSideNumber' })
  vehSideNumber: string;
  @Expose({ name: 'latitude' })
  latitude: number;
  @Expose({ name: 'longitude' })
  longitude: number;
  @Expose({ name: 'stopPileCode' })
  stopPileCode: string;
  @Expose({ name: 'scheduledDepartureTime' })
  scheduledDepartureTime: Date;


  getClassName(): string {
    return 'GPS_FRAME_PHANTOM';
  }

  getPosition(): LatLng {
    return L.latLng(this.latitude, this.longitude);
  }
}
